<!-- `al-portal` ist der Token-Scope des CI-Pakets (design/portal-ci/).
     Er sitzt bewusst auf nb-layout und nicht auf der Inhaltsspalte: Nebular
     hängt den CDK-Overlay-Container INNERHALB nb-layout ein, und nur von
     hier aus erben Dialoge, Dropdowns und Tooltips dieselben Tokens.
     Nur Custom Properties — die bilden keinen Stacking-Context, die Regel
     aus CLAUDE.md 12 bleibt also unberührt. -->
<nb-layout class="dashboard-layout-host al-portal" [class.al-creator-focus]="creatorFocus.focus()">
  <nb-layout-header fixed>
    <app-dashboard-header></app-dashboard-header>
    <app-info-bar></app-info-bar>
  </nb-layout-header>

  <nb-sidebar tag="menu-sidebar">
    <nb-menu [items]="menu"></nb-menu>
    <button class="sidebar-collapse-btn" (click)="toggleSidebar()">
      <nb-icon [icon]="sidebarExpanded ? 'chevron-left-outline' : 'chevron-right-outline'"></nb-icon>
    </button>
  </nb-sidebar>

  <nb-layout-column
    class="colored-column-basic"
    [class.agent-panel-open]="agentChat.open()"
    [style.--agent-panel-width]="agentChat.width() + 'px'"
  >
    <app-grain-pulse></app-grain-pulse>
    <router-outlet></router-outlet
    >
    <!-- Portal-Hinweise (unten links, position: fixed) — z. B. „Erstelle
         eine Wissensbasis". Steht in der Inhaltsspalte, damit sie im
         `.al-portal`-Scope liegt. -->
    <app-portal-hints></app-portal-hints>
    <!-- Datei-Uploads im Hintergrund (unten rechts, position: fixed). -->
    <app-upload-tray></app-upload-tray>
    <!-- Hausagent: Panel rechts + Spotlight. In der Inhaltsspalte, nicht als
         Geschwister: nb-layout projiziert nur nb-sidebar/-column/-header/
         -footer, ein freies Kind verschwände. Beide sind position: fixed. -->
    <app-agent-panel></app-agent-panel>
    <app-agent-spotlight></app-agent-spotlight
  ></nb-layout-column>
</nb-layout>
